module.exports = __webpack_public_path__ + "static/media/ring_red.d8057031.png";